import {useState, useCallback, useEffect} from 'react';
import {useBlocker} from 'react-router';

export const useBlockNavigationIfFormDirty = () => {
  const [isFormDirty, setIsFormDirty] = useState(false);
  const blocker = useBlocker(isFormDirty);
  const isNavigationBlocked = blocker.state === 'blocked';

  const onConfirmNavigation = useCallback(async () => {
    setIsFormDirty(false);
    blocker.proceed?.();
  }, [blocker, setIsFormDirty]);

  const onCancelNavigation = useCallback(() => {
    blocker.reset?.();
  }, [blocker]);

  useEffect(() => () => blocker.reset?.(), [blocker]);

  return {setIsFormDirty, isNavigationBlocked, onConfirmNavigation, onCancelNavigation};
};
